import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserForm = _resolveComponent("UserForm")!
  const _component_CompanyForm = _resolveComponent("CompanyForm")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ loading: _ctx.userIsLoading })
  }, [
    _createVNode(_component_UserForm, {
      modelValue: _ctx.userDetails,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userDetails) = $event)),
      errors: _ctx.errors,
      "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errors) = $event)),
      isValid: _ctx.isUserFormValid,
      "onUpdate:isValid": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isUserFormValid) = $event)),
      formQuestions: _ctx.formQuestions,
      userResponses: _ctx.userResponses,
      config: { ..._ctx.config, admin: true },
      genders: _ctx.genders,
      languages: _ctx.languages,
      hiddenUserFields: _ctx.hiddenUserFields,
      additionalFields: _ctx.additionalFields,
      autocomplete: false,
      onDoChange: _ctx.handleDoChange,
      onSelectChange: _ctx.handleSelectChange,
      onChoiceChange: _ctx.handleChoiceChange,
      onCheckboxChange: _ctx.handleCheckboxChange,
      onUpdateAdditionalField: _ctx.handleUpdateAdditionalField
    }, null, 8, ["modelValue", "errors", "isValid", "formQuestions", "userResponses", "config", "genders", "languages", "hiddenUserFields", "additionalFields", "onDoChange", "onSelectChange", "onChoiceChange", "onCheckboxChange", "onUpdateAdditionalField"]),
    _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
    _createVNode(_component_CompanyForm, {
      hiddenUserFields: _ctx.hiddenUserFields,
      modelValue: _ctx.userDetails,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userDetails) = $event)),
      errors: _ctx.errors,
      "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.errors) = $event)),
      isValid: _ctx.isCompanyFormValid,
      "onUpdate:isValid": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isCompanyFormValid) = $event)),
      managers: _ctx.managers,
      groups: _ctx.groups,
      roles: _ctx.roles,
      config: _ctx.config,
      requiredUserFields: _ctx.requiredUserFields,
      additionalFields: _ctx.additionalFields,
      autocomplete: false,
      onUpdateAdditionalField: _ctx.handleUpdateAdditionalField,
      class: _normalizeClass({ error: !_ctx.isCompanyFormValid })
    }, null, 8, ["hiddenUserFields", "modelValue", "errors", "isValid", "managers", "groups", "roles", "config", "requiredUserFields", "additionalFields", "onUpdateAdditionalField", "class"]),
    (_ctx.isMounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: ".page-content-footer"
        }, [
          (!_ctx.isNewUser)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                text: "prompts.discard-changes.title",
                size: "sm",
                disabled: !_ctx.isDirty,
                onClick: _ctx.handleDiscardChanges,
                variant: "secondary"
              }, null, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            text: "common.save",
            "data-test-ref": "save-user",
            size: "sm",
            disabled: !_ctx.isDirty,
            onClick: _ctx.handleSave
          }, null, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}